export const MAX_PHRASE_LENGTH = 1000;
